import { render, staticRenderFns } from "./port.vue?vue&type=template&id=ff38a5ec&scoped=true&"
import script from "./port.vue?vue&type=script&lang=js&"
export * from "./port.vue?vue&type=script&lang=js&"
import style0 from "./port.vue?vue&type=style&index=0&id=ff38a5ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff38a5ec",
  null
  
)

export default component.exports